import { render, staticRenderFns } from "./dast_issue_body.vue?vue&type=template&id=747d54f8&"
import script from "./dast_issue_body.vue?vue&type=script&lang=js&"
export * from "./dast_issue_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports